var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "68.2 69.1 63.6 63.7",
    viewBox: "68.2 69.1 63.6 63.7",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.8 100.9c0-17.6-14.2-31.8-31.8-31.8-8.8 0-16.7 3.6-22.5 9.3l45 45c5.7-5.7 9.3-13.7 9.3-22.5z",
    fill: "#0496FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 78.5l-9.3-9.3v63.6h63.6l-9.3-9.3-45-45zm1.7 43.3v-26l26 26h-26z",
    fill: "#5E17EB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0496FF",
    d: "M79.2 95.8v26h26l-26-26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvices);
export default __webpack_public_path__ + "static/media/advices.bbb12589da821e730a7a163f9d92f5c8.svg";
export { ForwardRef as ReactComponent };